export async function createOrUpdate({ commit }, { id, payload }) {
  const result = await this.$adminRepositories.appModals.createOrUpdate(payload);
  const { errResponse, data: responseData } = result;
  if(!errResponse) {
    if (!id) {
      await commit('admin/applications/addModal', responseData.data, {root: true});
    } else {
      await commit('admin/applications/updateModal', responseData.data, {root: true});
    }
  }
  return result;
}

export async function deleteModal({commit}, id) {
  const response = await this.$adminRepositories.appModals.delete(id);
  await commit('admin/applications/removeModal', id, {root: true});
  return response;
}